window.theme = window.theme || {}
window.theme.results = window.theme.results || {}

window.theme.results.events = {
  UI: {
    FACET_ADDED: 'listings:ui:facets:added',
    FACET_REMOVED: 'listings:ui:facet:removed',
    FACET_CLEAR_ALL: 'listings:ui:facet:clearAll',
    SORT_CHANGED: 'listings:ui:sort:changed',
    PRICE_CHANGED: 'listings:ui:price:changed',
    PAGINATION_NEXT: 'listings:ui:pagination:next',
  },

  API: {
    FETCH_PRODUCTS: 'listings:api:fetch:products',
    PRODUCTS_FETCHED: 'listings:api:products:fetched',
    FACETS_FETCHED: 'listings:api:facets:fetched',
    SHOPIFY_FALLBACK: 'listings:shopify:products:fetched',
  },

  STATE: {
    PRODUCTS_UPDATED: 'listings:state:products:updated',
    FACETS_UPDATED: 'listings:state:facets:updated',
    ACTIVE_FACETS_UPDATED: 'listings:state:activeFacets:updated',
    ACTIVE_SORT_UPDATED: 'listings:state:activeSort:updated',
    PAGINATION_UPDATED: 'listings:state:pagination:updated',
    SEARCH_TOTAL_UPDATED: 'listings:state:searchTotal:updated',
  },

  TRACKING: {
    PRODUCT_CLICKED: 'listings:tracking:product:clicked',
    PRODUCT_ADDED_TO_CART: 'listings:tracking:product:added',
  },
}
